// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as AuthContextV1$PorterinFeature from "../../../login/view-model/contexts/auth-context/AuthContextV1.mjs";
import * as LoadingSpinner$PorterinFeature from "../../../../ui/components/LoadingSpinner.mjs";
import * as CategoryCardCmp$PorterinFeature from "../../../../ui/components/CategoryCardCmp.mjs";
import * as CitySelectorCmp$PorterinFeature from "./CitySelectorCmp.mjs";
import * as EstimateCardCmp$PorterinFeature from "../../../../ui/components/EstimateCardCmp.mjs";
import * as LiveOrderCardCmp$PorterinFeature from "../../../order-history/view/components/LiveOrderCardCmp.mjs";
import * as ServicesCategoryModuleScss from "../styles/ServicesCategory.module.scss";

var styles = ServicesCategoryModuleScss;

function ServicesCategoryCmp(Props) {
  var city_selector_data = Props.city_selector_data;
  var city_selected = Props.city_selected;
  var fare_estimate_form_content = Props.fare_estimate_form_content;
  var content = Props.content;
  var is_enterprise_v2_enabledOpt = Props.is_enterprise_v2_enabled;
  var is_enterprise_v2_enabled = is_enterprise_v2_enabledOpt !== undefined ? is_enterprise_v2_enabledOpt : false;
  var match = React.useState(function () {
        return false;
      });
  var setIsRedirecting = match[1];
  var is_redirecting = match[0];
  var match$1 = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var icons = content.icons;
  var fare_estimate = content.fare_estimate;
  var order_history = match$1.order_history;
  var tmp;
  if (typeof order_history === "number" || order_history.TAG !== /* Live */1) {
    tmp = null;
  } else {
    var match$2 = order_history._0.length;
    tmp = match$2 !== 0 ? React.createElement("div", {
            className: styles["live-order-wrapper"]
          }, React.createElement(LiveOrderCardCmp$PorterinFeature.make, {})) : null;
  }
  return React.createElement("div", {
              className: styles["service-category-container"]
            }, React.createElement("div", {
                  className: "" + styles["service-category-wrapper"] + " " + (
                    is_enterprise_v2_enabled ? styles["enterprise-v2"] : ""
                  ) + ""
                }, tmp, React.createElement(CitySelectorCmp$PorterinFeature.make, {
                      city_selector_data: city_selector_data,
                      location_icon: icons.location_icon,
                      drop_down_icon: icons.drop_down_icon,
                      close_icon: icons.close_icon,
                      city_title_desc: content.city_title_desc,
                      city_label_prefix: content.city_label_prefix
                    }), React.createElement("div", {
                      className: styles["service-cards-container"]
                    }, city_selected !== undefined ? React.createElement("div", {
                            className: styles["service-cards-wrapper"]
                          }, Belt_Array.mapWithIndex(city_selected.city_services, (function (index, card) {
                                  return React.createElement(CategoryCardCmp$PorterinFeature.make, {
                                              service: card,
                                              is_redirecting: is_redirecting,
                                              setIsRedirecting: setIsRedirecting,
                                              key: String(index)
                                            });
                                })), React.createElement(EstimateCardCmp$PorterinFeature.make, {
                                category_cards_data: city_selected.city_services,
                                fare_estimate_form_content: fare_estimate_form_content,
                                fare_estimate_action: fare_estimate.get_estimate_action,
                                modal_content: fare_estimate
                              })) : React.createElement(LoadingSpinner$PorterinFeature.make, {}))));
}

var make = ServicesCategoryCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
